import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-edf65fee"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select country", -1));
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_flag_value = _resolveComponent("flag-value");
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_product_score = _resolveComponent("product-score");
  const _component_app_circle_progress = _resolveComponent("app-circle-progress");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  return _openBlock(), _createBlock(_component_app_dropdown, {
    class: _normalizeClass(['translate-dropdown']),
    modelValue: $data.selected,
    "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => $data.selected = $event), $options.selectOption],
    options: $data.options
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_flex_row, {
      gap: 8
    }, {
      default: _withCtx(() => [!$data.selected ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!$data.selected ? (_openBlock(), _createBlock(_component_app_icon, {
        key: 0,
        icon: "marketplaces",
        size: "20",
        color: "#757575"
      })) : _createCommentVNode("", true), _hoisted_1], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_flag_value, {
        flag: $options.countryFlag
      }, null, 8, ["flag"]), _createElementVNode("span", null, _toDisplayString($data.selected), 1), _createVNode(_component_b_popover, {
        target: "calculating-score",
        triggers: "hover",
        placement: "top",
        "custom-class": "popover-calc-score"
      }, {
        default: _withCtx(() => [_createTextVNode(" Calculating score ")]),
        _: 1
      }), $data.calculating_score ? (_openBlock(), _createBlock(_component_app_icon, {
        key: 0,
        icon: "loading",
        size: "20",
        color: "#736BC9",
        class: "icon-spin",
        id: "calculating-score"
      })) : _createCommentVNode("", true), !$data.calculating_score && $data.listing_not_found ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_b_popover, {
        target: "no-listing",
        triggers: "hover",
        placement: "top",
        "custom-class": "popover-no-listing"
      }, {
        default: _withCtx(() => [_createTextVNode(" Listing not found ")]),
        _: 1
      }), _createVNode(_component_product_score, {
        size: "20",
        score: "X",
        color: "#DB333B",
        id: "no-listing"
      })])) : _createCommentVNode("", true), !$data.calculating_score && !$data.listing_not_found && $data.item ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_b_popover, {
        target: "listing-score",
        triggers: "hover",
        placement: "top",
        "custom-class": "popover-calc-score"
      }, {
        default: _withCtx(() => [_createTextVNode(" Listing score ")]),
        _: 1
      }), _createVNode(_component_app_circle_progress, {
        simple: "",
        value: $data.item.success_rules,
        maxValue: $data.item.all_rules,
        size: 20,
        stroke: 3,
        font: 10,
        id: "listing-score"
      }, null, 8, ["value", "maxValue"])])) : _createCommentVNode("", true)], 64))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "options", "onUpdate:modelValue"]);
}